import { Line } from '@nivo/line';
import { Redirect } from 'react-router';
import React, { Component } from 'react';
import { AutoSizer } from 'react-virtualized';
import './WeekChart.css';

export default class WeekChart extends Component {

  constructor(props)
  {
    super(props);
    this.state = {
      toSleepEntry: false,
      linkData: "",
      tickMarks: "every 1 days",
    }
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount()
    {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount(){
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions(){
    if(window.innerWidth >= 1000)
    {
      this.setState({tickMarks: 'every 1 days'});
    }
    else if(window.innerWidth > 800 && window.innerWidth < 1000)
    {
      this.setState({tickMarks: 'every 2 days'});
    }
    else if(window.innerWidth > 500 && window.innerWidth < 800)
    {
      this.setState({tickMarks: 'every 3 days'})
    }
    else if(window.innerWidth > 400 && window.innerWidth < 500)
    {
      this.setState({tickMarks: 'every 4 days'})
    }
    else{
      this.setState({tickMarks: 'every 7 days'});
    }
  }

  render() {

    const commonProperties = {
      margin: { top: 20, right: 20, bottom: 60, left: 80 },
      animate: true,
    }

    if (this.state.toSleepEntry === true) {
      return <Redirect to={`${process.env.PUBLIC_URL}/sleepEntry/${this.state.linkData}`} />
    }

    return (
      <div className="lineChart">
        <AutoSizer>
          {({ height, width }) => (
            <Line
              height={height}
              width={width}
              {...commonProperties}
              data={this.props.sleepData}
              margin={{ top: 50, right: 110, bottom: 50, left: 60 }}
              xScale={{
                type: 'time',
                format: 'native',
              }}
              xFormat='time:%b %d %Y'
              yScale={{ type: 'linear', stacked: false, min: 'auto', max: 'auto' }}
              axisBottom={{
                format: '%e',
                tickValues: this.state.tickMarks,
                legend: '',
                legendOffset: -12,
              }}
              colors={['#5434dd', '#e635e4']}
              axisLeft={{
                legend: '',
                legendOffset: 12,
              }}
              curve={'monotoneX'}
              lineWidth={4}
              pointSize={18}
              pointBorderWidth={4}
              enableGridX={false}
              pointColor="white"
              pointBorderColor={{ from: 'serieColor' }}
              pointLabel="y"
              pointLabelYOffset={-12}
              useMesh={true}
              onClick={(data, e) => {
                this.setState({ linkData: data.data.link });
                this.setState({ toSleepEntry: true });
              }}
              legends={[
                {
                  anchor: 'bottom-right',
                  direction: 'column',
                  justify: false,
                  translateX: 100,
                  translateY: 0,
                  itemsSpacing: 0,
                  itemDirection: 'left-to-right',
                  itemWidth: 80,
                  itemHeight: 20,
                  itemOpacity: 0.75,
                  symbolSize: 14,
                  symbolShape: 'circle',
                  symbolBorderColor: 'rgba(0, 0, 0, .5)',
                  effects: [
                    {
                      on: 'hover',
                      style: {
                        itemBackground: 'rgba(0, 0, 0, .03)',
                        itemOpacity: 1
                      }
                    }
                  ]
                }
              ]}
              tooltip={({ point }) => {
                return (
                  <div
                    style={{
                      borderRadius: '5px',
                      background: 'white',
                      padding: '9px 12px',
                      border: '1px solid #ccc',
                      width: '150px'
                    }} >
                    <div>{point.data.xFormatted}</div>
                    <div>{point.serieId}: {point.data.yFormatted}</div>
                    <div style={{ fontSize: 10, fontWeight: 800, color: "gray", lineHeight: 3 }}>CLICK TO EDIT</div>
                  </div>
                );
              }}
              theme={{
                axis: {
                  ticks: {
                    text: {
                      fill: "black",
                      fontSize: 14,
                      fontWeight: 800
                    }
                  }
                },
                legends: {
                  text: {
                    fontSize: 14
                  }
                },
              }}
            />
          )}
        </AutoSizer>
      </div>
    )
  }
}



